import dictMixin from '@/mixins/dict-mixin';
const getDictItemName = dictMixin.methods.getDictItemName;

import { mapGetters } from 'vuex';

export default {
    data () {
        return {
            fieldKey: 'itemText'
        }
    },
    computed: {
        ...mapGetters('language', ['languageStorage']),
    },
    watch: {
        languageStorage: {
            handler (lang) {
                console.log("select lang----------->>>",lang)
                if (lang == 'en-US') {
                    this.fieldKey = 'itemTextEn';
                } else if (lang == 'zh-CN') {
                    this.fieldKey = 'itemText';
                }else if(lang == 'ti') {
                    this.fieldKey = 'itemTextTha';
                }
            },
            immediate: true,
        }
    },
    created () {
        this.getDict();
    },
    methods: {
        getDictItemName (type, value) {
            console.log('---------key',this.fieldKey)
            console.log(getDictItemName.call(this, type, value, this.fieldKey))
            return getDictItemName.call(this, type, value, this.fieldKey);
        }
    },
}